module.exports = __webpack_public_path__ + "img/Loading_r_50.ce9944bf.png";